export const concatPhoneNumber = (
  phone: string,
  countryCallingCode: string,
) => {
  return `+${countryCallingCode}${phone}`;
};
